module.exports = __webpack_public_path__ + "static/novartis_logo_pos_rgb-3476bd8d3447f477edc32316fcb3acba.png";